import { render, staticRenderFns } from "./ServeSale202301Step2.vue?vue&type=template&id=636ef130&scoped=true"
import script from "./ServeSale202301Step2.vue?vue&type=script&lang=js"
export * from "./ServeSale202301Step2.vue?vue&type=script&lang=js"
import style0 from "./ServeSale202301Step2.vue?vue&type=style&index=0&id=636ef130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ef130",
  null
  
)

export default component.exports